<app-page-breadcrumb pageTitle="Negocios"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <!-- Left side - Owner filter toggle -->
    <div class="flex items-center gap-1.5">
      <div
        class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden"
      >
        <button
          type="button"
          (click)="setOwnerFilter()"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="
            filtroOwner === undefined
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Todos
        </button>
        <button
          type="button"
          (click)="setOwnerFilter()"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="
            filtroOwner === currentUser
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Mis negocios
        </button>
        <button
          type="button"
          (click)="setArchivesDeals()"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="
            archived
              ? 'bg-brand-500 text-white'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
          "
        >
          Archivados
        </button>
      </div>
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
      <button
        type="button"
        (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
          ></path>
        </svg>
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button
        type="button"
        (click)="vistaTablero()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 17V7m0 10a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h2a2 2 0 012 2m0 10a2 2 0 002 2h2a2 2 0 002-2M9 7a2 2 0 012-2h2a2 2 0 012 2m0 10V7m0 10a2 2 0 002 2h2a2 2 0 002-2V7a2 2 0 00-2-2h-2a2 2 0 00-2 2"
          ></path>
        </svg>
        Kanban
      </button>
      <button
        type="button"
        *appHasPermission="'deals:create'"
        (click)="nuevoDeal()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5"
      >
        <svg
          class="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 4v16m8-8H4"
          ></path>
        </svg>
        Nuevo Negocio
      </button>
    </div>
  </div>

  <!-- Compact Filters Panel -->
  @if (showFilters) {
    <div
      class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3"
    >
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
        <!-- Búsqueda por nombre -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por nombre
          </label>
          <input
            type="text"
            [(ngModel)]="filtroNombre"
            (ngModelChange)="buscarTexto()"
            placeholder="Nombre del negocio..."
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro Tipo de Negocio -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Tipo de Negocio
          </label>
          <select
            [(ngModel)]="filtroDealBusinessType"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos los tipos</option>
            @for (bt of dealBusinessTypes; track bt.id) {
              <option [ngValue]="bt.id">{{ bt.name }}</option>
            }
          </select>
        </div>
        <!-- Filtro Prioridad -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Prioridad
          </label>
          <select
            [(ngModel)]="filtroDealPriority"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todas las prioridades</option>
            @for (p of dealPriorities; track p.id) {
              <option [ngValue]="p.id">{{ p.name }}</option>
            }
          </select>
        </div>

        <!-- Valor mínimo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Valor mínimo
          </label>
          <input
            type="number"
            [(ngModel)]="filtroMinAmount"
            (ngModelChange)="buscar()"
            placeholder="0.00"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Valor máximo -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Valor máximo
          </label>
          <input
            type="number"
            [(ngModel)]="filtroMaxAmount"
            (ngModelChange)="buscar()"
            placeholder="999999.99"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>
        <!-- Filtro Estado -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Estado
          </label>
          <select
            [(ngModel)]="filtroActiveOnly"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todos</option>
            <option [ngValue]="true">Solo activos</option>
            <option [ngValue]="false">Solo cerrados</option>
          </select>
        </div>
        <!-- Filtro Por Responsable (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Responsable
          </label>
          <app-entity-select
            [value]="filtroOwner ?? null"
            [displayText]="ownerFilterDisplay"
            [searchFn]="userSearch"
            [labelFn]="userLabel"
            [sublabelFn]="userSublabel"
            (valueChange)="onOwnerFilterChange($event)"
            placeholder="Buscar responsable por nombre o correo…"
          ></app-entity-select>
        </div>

        <!-- Filtro Por Empresa (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Empresa
          </label>
          <app-entity-select
            [value]="filtroCompanyId ?? null"
            [displayText]="filtroCompanyName"
            [searchFn]="companyFilterSearch"
            [labelFn]="companyFilterLabel"
            (valueChange)="onCompanyFilterChange($event)"
            (selected)="filtroCompanyName = $event ? $event.commercialName : ''"
            placeholder="Buscar empresa por nombre…"
          ></app-entity-select>
        </div>

        <!-- Filtro Fecha de cierre estimada (Inc 23) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Cierre estimado desde
          </label>
          <input
            type="date"
            [(ngModel)]="filtroEstimatedCloseFrom"
            (ngModelChange)="buscar()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Cierre estimado hasta
          </label>
          <input
            type="date"
            [(ngModel)]="filtroEstimatedCloseTo"
            (ngModelChange)="buscar()"
            (click)="$any($event.target).showPicker?.()"
            (focus)="$any($event.target).showPicker?.()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>
        <!-- Búsqueda por contacto -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Buscar por contacto
          </label>
          <input
            type="text"
            [(ngModel)]="filtroContacto"
            (ngModelChange)="buscarTexto()"
            placeholder="Nombre o correo del contacto…"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          />
        </div>

        <!-- Filtro País (por prefijo telefónico del contacto principal) -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            País
          </label>
          <app-country-select
            [countries]="filterCountries"
            [value]="filtroPais"
            [clearable]="true"
            placeholder="Todos"
            (valueChange)="onCountryFilterChange($event)" />
        </div>
        <!-- Filtro Deal Cycle -->
        <div>
          <label
            class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
          >
            Etapa del Negocio
          </label>
          <select
            [(ngModel)]="filtroDealCycle"
            (ngModelChange)="buscar()"
            class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
          >
            <option [ngValue]="undefined">Todas las etapas</option>
            @for (cycle of dealCycles; track cycle.id) {
              <option [ngValue]="cycle.id">{{ cycle.name }}</option>
            }
          </select>
        </div>

        <!-- Botón Limpiar Filtros (spans 2 columns) -->
        <div class="md:col-span-2 flex items-end">
          <button
            type="button"
            (click)="limpiarFiltro()"
            class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700"
          >
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="flex justify-center items-center py-12">
      <div
        class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"
      ></div>
      <span class="ml-3 text-gray-500 dark:text-gray-400"
        >Cargando deals...</span
      >
    </div>
  }

  <!-- Error -->
  @if (error) {
    <div
      class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20"
    >
      <div class="flex items-center gap-3">
        <svg
          class="w-5 h-5 text-error-500"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <p class="text-error-600 dark:text-error-400">{{ error }}</p>
      </div>
    </div>
  }

  <!-- Barra de acciones masivas -->
  @if (!loading && !error && selectedDealIds.length > 0) {
    <div
      class="flex items-center justify-between gap-3 px-4 py-3 bg-brand-50 dark:bg-brand-900/20 rounded-xl border border-brand-100 dark:border-brand-800"
    >
      <div class="flex items-center gap-2">
        <span
          class="flex h-6 w-6 items-center justify-center rounded-full bg-brand-500 text-xs font-bold text-white"
        >
          {{ selectedDealIds.length }}
        </span>
        <span class="text-sm font-medium text-brand-700 dark:text-brand-400"
          >negocio(s) seleccionado(s)</span
        >
      </div>
      <div class="flex gap-2">
        <button
          *appHasPermission="'deals:edit'"
          (click)="openBulkActionModal('CHANGE_OWNER')"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-brand-200 dark:border-brand-700 text-brand-600 dark:text-brand-400 text-xs font-medium rounded-lg hover:bg-brand-50 dark:hover:bg-brand-900/20 transition-colors"
        >
          <svg
            class="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
          Cambiar responsable
        </button>
        <button
          *appHasPermission="'deals:edit'"
          (click)="openBulkActionModal('CHANGE_STAGE')"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-indigo-200 dark:border-indigo-700 text-indigo-600 dark:text-indigo-400 text-xs font-medium rounded-lg hover:bg-indigo-50 dark:hover:bg-indigo-900/20 transition-colors"
        >
          <svg
            class="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 10h16M4 14h16M4 18h16"
            />
          </svg>
          Cambiar etapa
        </button>
        <button
          *appHasPermission="'deals:delete'"
          (click)="openBulkActionModal('DELETE')"
          class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white dark:bg-gray-800 border border-red-200 dark:border-red-700 text-red-600 dark:text-red-400 text-xs font-medium rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
        >
          <svg
            class="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            />
          </svg>
          Eliminar
        </button>
      </div>
    </div>
  }

  <!-- Tabla de deals -->
  @if (!loading && !error) {
    <div
      class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/3"
    >
      <div class="max-w-full overflow-x-auto custom-scrollbar">
        <table class="min-w-full">
          <!-- Table Header -->
          <thead class="border-b border-gray-100 dark:border-white/5">
            <tr>
              <th class="px-5 py-3 w-12 text-center">
                <input
                  type="checkbox"
                  class="w-4 h-4 text-brand-500 bg-white border-gray-300 rounded focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-700 cursor-pointer"
                  [checked]="isAllDealsSelected"
                  (change)="toggleAllDeals($event)"
                />
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Nombre
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Monto
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400"
              >
                Empresa
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Fecha de cierre
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400"
              >
                Etapa
              </th>
              <th
                class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400"
              >
                Acciones
              </th>
            </tr>
          </thead>

          <!-- Table Body -->
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @if (deals.length === 0) {
              <tr>
                <td
                  colspan="7"
                  class="px-5 py-8 text-center"
                >
                  <div
                    class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400"
                  >
                    <svg
                      class="w-12 h-12"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="1"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                      ></path>
                    </svg>
                    <span>No hay deals registrados</span>
                  </div>
                </td>
              </tr>
            }

            @for (deal of deals; track deal.id) {
              <tr
                [class.opacity-60]="isClosed(deal)"
                [ngClass]="{
                  'bg-brand-50/30 dark:bg-brand-900/10': isDealSelected(
                    deal.id
                  ),
                }"
              >
                <td class="px-4 py-3 text-center">
                  <input
                    type="checkbox"
                    class="w-4 h-4 text-brand-500 bg-white border-gray-300 rounded focus:ring-brand-500 dark:border-gray-600 dark:bg-gray-700 cursor-pointer"
                    [checked]="isDealSelected(deal.id)"
                    (change)="toggleDealSelection(deal.id)"
                  />
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="flex items-center gap-2 font-medium text-gray-800 dark:text-white/90"
                  >
                    @if (countryFlagCode(deal.primaryContactPhone); as cc) {
                      <span class="fi fi-{{ cc }} rounded-sm shrink-0"
                        [title]="countryName(deal.primaryContactPhone) + (deal.primaryContactName ? ' · ' + deal.primaryContactName : '')"></span>
                    }
                    {{ deal.name }}
                    @if (deal.archived) {
                      <span
                        class="inline-flex items-center rounded-full bg-orange-100 dark:bg-orange-900/30 px-2 py-0.5 text-[10px] font-semibold text-orange-700 dark:text-orange-400"
                      >
                        Archivado
                      </span>
                    }
                  </span>
                  @if (deal.description) {
                    <span
                      class="block text-xs text-gray-500 dark:text-gray-400 truncate max-w-xs"
                    >
                      {{ deal.description }}
                    </span>
                  }
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <span
                    class="font-semibold text-gray-800 dark:text-white/90 text-xs"
                  >
                    {{ getDealAmountDisplay(deal) }}
                  </span>
                </td>
                <td class="px-4 py-3 text-center text-theme-sm">
                  @if (deal.idCompany) {
                    <span
                      class="text-success-600 dark:text-success-400 text-lg font-bold"
                      >✓</span
                    >
                  } @else {
                    <span
                      class="text-error-600 dark:text-error-400 text-lg font-bold"
                      >✗</span
                    >
                  }
                </td>
                <td class="px-4 py-3 text-start text-theme-sm">
                  @if (deal.datetimeEstimatedClose) {
                    <span
                      class="font-semibold text-gray-800 dark:text-white/90 text-xs"
                      >{{ formatDate(deal.datetimeEstimatedClose) }}</span
                    >
                  } @else {
                    <span
                      class="font-semibold text-gray-800 dark:text-white/90 text-xs"
                      >-</span
                    >
                  }
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400"
                >
                  <app-badge [color]="getDealStatusBadgeColor(deal)">
                    {{ deal.dealCycleName || getCycleName(deal.idDealCycle) }}
                  </app-badge>
                </td>
                <td
                  class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400"
                >
                  <div class="flex items-center justify-center gap-2">
                    <button
                      (click)="verDetalle(deal)"
                      class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                      title="Ver detalle"
                    >
                      <svg
                        class="w-4 h-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        ></path>
                      </svg>
                    </button>
                    @if (!isClosed(deal)) {
                      <button
                        (click)="editarDeal(deal)"
                        *appHasPermission="'deals:edit'"
                        class="rounded-lg p-2 hover:text-brand-500 hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
                        title="Editar"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                          ></path>
                        </svg>
                      </button>
                      <button
                        (click)="nuevaCotizacion(deal)"
                        class="rounded-lg p-2 hover:bg-green-100 dark:hover:bg-green-900/20 hover:text-green-600 dark:hover:text-green-400 transition-colors"
                        title="Nueva cotización"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                          ></path>
                        </svg>
                      </button>
                      <button
                        (click)="nuevaCopia(deal)"
                        *appHasPermission="'deals:create'"
                        class="rounded-lg p-2 hover:bg-purple-100 dark:hover:bg-purple-900/20 hover:text-purple-600 dark:hover:text-purple-400 transition-colors"
                        title="Nueva copia"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                          ></path>
                        </svg>
                      </button>

                      <button
                        (click)="closeDeal(deal)"
                        *appHasPermission="'deals:edit'"
                        title="Cerrar"
                        class="rounded-lg p-2 hover:bg-red-100 dark:hover:bg-red-900/20 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
                          />
                        </svg>
                      </button>
                      <button
                        (click)="eliminarDeal(deal)"
                        *appHasPermission="'deals:delete'"
                        class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                        title="Eliminar"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                          ></path>
                        </svg>
                      </button>
                    } @else {
                      <button
                        (click)="reOpenDeal(deal)"
                        *appHasPermission="'deals:edit'"
                        title="Reabrir"
                        class="p-2 rounded-lg hover:text-gray-500 hover:bg-gray-100 dark:hover:bg-gray-700"
                      >
                        <svg
                          class="w-4 h-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                          />
                        </svg>
                      </button>
                    }
                    @if (deal.archived) {
                      <button
                        type="button"
                        (click)="unarchiveDeal(deal)"
                        *appHasPermission="'deals:edit'"
                        title="Desarchivar"
                        class="rounded-lg p-2 hover:bg-orange-100 dark:hover:bg-orange-900/20 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                      >
                        <svg
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-5 5l-3-3m0 0l-3 3m3-3v6"
                          ></path>
                        </svg>
                      </button>
                    } @else {
                      <button
                        type="button"
                        (click)="archiveDeal(deal)"
                        *appHasPermission="'deals:edit'"
                        title="Archivar"
                        class="rounded-lg p-2 hover:bg-orange-100 dark:hover:bg-orange-900/20 hover:text-orange-600 dark:hover:text-orange-400 transition-colors"
                      >
                        <svg
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                          class="w-4 h-4"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
                          ></path>
                        </svg>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Paginación -->
      @if (globalTotalPages >= 1) {
        <div
          class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4"
        >
          <div class="flex items-center justify-between gap-4 flex-wrap">
            <div class="flex items-center gap-2">
              <span class="text-sm text-gray-500 dark:text-gray-400"
                >{{ globalTotalElements }} registros</span
              >
              <select
                [ngModel]="pageSize"
                (ngModelChange)="changePageSize($event)"
                class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                @for (opt of PAGE_SIZE_OPTIONS; track opt) {
                  <option [value]="opt">{{ opt }}</option>
                }
              </select>
            </div>
            <div class="flex items-center gap-2">
              <button
                type="button"
                (click)="cambiarPagina(globalPage - 1)"
                [disabled]="!hasPrevPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Anterior
              </button>
              <div class="flex items-center gap-1.5">
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >Página</span
                >
                <select
                  [ngModel]="pageDisplay"
                  (ngModelChange)="cambiarPagina($event - 1)"
                  class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                >
                  @for (p of pagesArray; track p) {
                    <option [value]="p">{{ p }}</option>
                  }
                </select>
                <span class="text-sm text-gray-500 dark:text-gray-400"
                  >de {{ globalTotalPages }}</span
                >
              </div>
              <button
                type="button"
                (click)="cambiarPagina(globalPage + 1)"
                [disabled]="!hasNextPage"
                class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
              >
                Siguiente
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  }
</div>

<!-- Modal de detalle -->
<app-deal-detail-modal
  [isOpen]="showDetailModal"
  [deal]="selectedDeal"
  [dealCycles]="dealCycles"
  [dealBusinessTypes]="dealBusinessTypes"
  [dealPriorities]="dealPriorities"
  (close)="cerrarModal()"
  (dealUpdated)="onDealUpdated()"
>
</app-deal-detail-modal>

<app-deal-close-reopen-modal
  [visible]="showDealModal"
  [deal]="selectedDeal"
  [action]="actionChangeCycle"
  [dealCycles]="dealCycles"
  (closed)="showDealModal = false"
  (closeDealInformation)="applyChangeCycle($event)"
>
</app-deal-close-reopen-modal>

<!-- Modal de acción masiva -->
@if (isBulkActionModalOpen) {
  <div
    class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50"
    (click)="closeBulkActionModal()"
  >
    <div
      class="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-md p-6 mx-4"
      (click)="$event.stopPropagation()"
    >
      <!-- Estado: confirmación -->
      @if (!bulkResult) {
        <div>
          <div class="text-center">
            <div
              class="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
              [ngClass]="
                bulkAction === 'DELETE'
                  ? 'bg-red-50 dark:bg-red-900/20'
                  : bulkAction === 'CHANGE_STAGE'
                    ? 'bg-indigo-50 dark:bg-indigo-900/20'
                    : 'bg-brand-50 dark:bg-brand-900/20'
              "
            >
              <svg
                class="w-7 h-7"
                [ngClass]="
                  bulkAction === 'DELETE'
                    ? 'text-red-500'
                    : bulkAction === 'CHANGE_STAGE'
                      ? 'text-indigo-500'
                      : 'text-brand-500'
                "
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                @if (bulkAction === 'CHANGE_OWNER') {
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  />
                } @else if (bulkAction === 'CHANGE_STAGE') {
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 6h16M4 10h16M4 14h16M4 18h16"
                  />
                } @else {
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                }
              </svg>
            </div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-2">
              {{ getBulkActionLabel(bulkAction) }}
            </h3>
            <p class="text-sm text-gray-500 dark:text-gray-400 mb-4">
              @if (bulkAction === 'CHANGE_OWNER') {
                Elige el nuevo responsable para
                <strong>{{ selectedDealIds.length }}</strong> negocio(s).
              }
              @if (bulkAction === 'CHANGE_STAGE') {
                Elige la nueva etapa para
                <strong>{{ selectedDealIds.length }}</strong> negocio(s).
              }
              @if (bulkAction === 'DELETE') {
                ¿Eliminar permanentemente
                <strong>{{ selectedDealIds.length }}</strong> negocio(s)? Esta
                acción no se puede deshacer.
              }
            </p>
          </div>

          <!-- Picker de responsable (solo CHANGE_OWNER) -->
          @if (bulkAction === 'CHANGE_OWNER') {
            <div class="mb-6 text-left">
              <label
                class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
                >Nuevo responsable</label
              >
              <app-entity-select
                [searchFn]="userSearch"
                [labelFn]="userLabel"
                [sublabelFn]="userSublabel"
                [value]="bulkOwnerId"
                (valueChange)="onBulkOwnerChange($event)"
                placeholder="Buscar por nombre o correo…"
              >
              </app-entity-select>
            </div>
          }

          <!-- Selector de etapa (solo CHANGE_STAGE) -->
          @if (bulkAction === 'CHANGE_STAGE') {
            <div class="mb-6 text-left">
              <label
                class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1"
                >Nueva etapa</label
              >
              <select
                [(ngModel)]="bulkCycleId"
                class="w-full px-2.5 py-2 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent"
              >
                <option [ngValue]="null">— Selecciona una etapa —</option>
                @for (cycle of dealCycles; track cycle.id) {
                  <option [ngValue]="cycle.id">{{ cycle.name }}</option>
                }
              </select>
            </div>
          }

          <div class="flex justify-center gap-3">
            <button
              (click)="closeBulkActionModal()"
              class="px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
            >
              Cancelar
            </button>
            <button
              (click)="ejecutarAccionMasiva()"
              [disabled]="
                isExecutingBulk ||
                (bulkAction === 'CHANGE_OWNER' && !bulkOwnerId) ||
                (bulkAction === 'CHANGE_STAGE' && !bulkCycleId)
              "
              [ngClass]="
                bulkAction === 'DELETE'
                  ? 'bg-red-500 hover:bg-red-600'
                  : bulkAction === 'CHANGE_STAGE'
                    ? 'bg-indigo-500 hover:bg-indigo-600'
                    : 'bg-brand-500 hover:bg-brand-600'
              "
              class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              @if (isExecutingBulk) {
                <div
                  class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"
                ></div>
              }
              Confirmar
            </button>
          </div>
        </div>
      }

      <!-- Estado: resultado -->
      @if (bulkResult) {
        <div>
          <div class="text-center">
            <div
              class="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
              [ngClass]="
                bulkResult.failed === 0
                  ? 'bg-emerald-50 dark:bg-emerald-900/20'
                  : 'bg-amber-50 dark:bg-amber-900/20'
              "
            >
              <svg
                class="w-7 h-7"
                [ngClass]="
                  bulkResult.failed === 0
                    ? 'text-emerald-500'
                    : 'text-amber-500'
                "
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 class="text-lg font-bold text-gray-900 dark:text-white mb-4">
              {{
                bulkResult.failed === 0
                  ? 'Acción completada'
                  : 'Acción completada parcialmente'
              }}
            </h3>
          </div>

          <div class="grid grid-cols-2 gap-3 mb-4">
            <div class="bg-gray-50 dark:bg-gray-800 rounded-xl p-3 text-center">
              <p class="text-xl font-black text-gray-800 dark:text-gray-200">
                {{ bulkResult.processed }}
              </p>
              <p
                class="text-[10px] font-bold text-gray-500 uppercase tracking-wide mt-1"
              >
                Procesados
              </p>
            </div>
            <div
              class="bg-red-50 dark:bg-red-900/20 rounded-xl p-3 text-center"
            >
              <p class="text-xl font-black text-red-600 dark:text-red-400">
                {{ bulkResult.failed }}
              </p>
              <p
                class="text-[10px] font-bold text-red-500 uppercase tracking-wide mt-1"
              >
                Fallidos
              </p>
            </div>
          </div>

          @if (bulkResult.failures.length > 0) {
            <div
              class="mb-4 max-h-48 overflow-y-auto rounded-xl border border-red-100 dark:border-red-900/40"
            >
              <ul class="divide-y divide-red-100 dark:divide-red-900/40">
                @for (f of bulkResult.failures; track f.id) {
                  <li class="px-3 py-2 text-left">
                    <p
                      class="text-xs font-semibold text-gray-700 dark:text-gray-300"
                      [title]="'Identificador interno: ' + f.id"
                    >
                      {{ getFailureName(f) }}
                    </p>
                    <p class="text-xs text-red-600 dark:text-red-400">
                      {{ f.reason }}
                    </p>
                  </li>
                }
              </ul>
            </div>
          }

          <button
            (click)="closeBulkActionModal()"
            class="w-full px-4 py-2.5 text-sm font-medium text-white bg-brand-500 rounded-xl hover:bg-brand-600 transition-colors"
          >
            Cerrar
          </button>
        </div>
      }
    </div>
  </div>
}
